<template>
    <div class="sidebar">
        <!-- 
            UPLOAD
            - MOSTRA O COMPONENTE DE SELECIONAR A PLANILHA
         -->
        <template v-if="showUploadComputed">
            <div class="sidebar-header">
                <div class="header">
                    <div class="title"><i class="fal fa-table"/> Importar planilha de leads</div>
                    <button class="button-close" @click="hide">
                        <i class="fal fa-times"/>
                    </button>
                </div>
            </div>
            <div class="sidebar-content scroll-color">
                <ui-load-indicator v-if="loader.fileUpload" bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />

                <div v-show="layout.showInputUpload" class="ui-upload">
                    <label class="ui-upload-box">
                        <input ref="fileInput" class="input"  accept=".xlsx,.xls" type="file" @change="openCodeConfirmModal($event)" />
                        <span class="icon"><i class="fal fa-upload"/></span>
                        <span class="label">Clique para selecionar sua planilha</span>
                    </label>
                    <div class="ui-upload-title" @click="downloadsPreadsheet">
                        Baixar a <span class="color-primary">planilha</span> exemplo para importação de leads.
                    </div>
                </div>

                <div v-show="layout.showUploadSuccess" class="ui-upload">
                    <div class="ui-upload-box success">
                        <span class="icon"><i class="fal fa-check"/></span>
                    </div>
                </div>
            </div>

            <code-confirm-modal
                text-confirm-button="Importar"
                :on-confirm="confirmCodeConfirmModal"
                icon="ui-spreadsheet"
                :design="'primary md'"
            >
                <template #title>
                    <div class="code-confirm-modal-title-container">
                        <p class="code-confirm-modal-title">Importação de Planilha</p>
                    </div>
                </template>
                <template #body>
                    <div class="code-confirm-modal-body-container">
                        <p class="code-confirm-modal-body-text">
                            <span class="code-confirm-modal-body-text-weight">Atenção:</span> Campos em branco não impedem a importação da 
                            planilha, mas podem comprometer o resultado final. 
                        </p>
                        <p class="code-confirm-modal-body-text">
                            Revise os dados antes de prosseguir.
                        </p>
                    </div>
                </template>
            </code-confirm-modal>
        </template>

        <!-- 
            FORMULÁRIO
            - MOSTRA O FORMULÁIO DE SELECIONAR O USUÁRIO
         -->
        <template v-else>
            <ui-select-user/>
        </template>
    </div>
</template>

<script>
    import { uiSearchBox, uiLoadIndicator } from '@/components/ui'
    import uiSelectUser from '@/components/ui-facilita/select-user'
    import { uiButton } from '@/components/ui/buttons'
    import codeConfirmModal from '@/components/ui-facilita/code-confirm-modal'

    import { lead } from '@/services/axios'

    import helpers from '@/mixins/helpers'

    import { mapGetters } from 'vuex'

    const defaultLayout = () => {
        return {
            showInputUpload: true,
            showUploadSuccess: false,
        }
    }

    const defaultLoader = () => {
        return {
            selectUser: false,
            fileUpload: false,
            form: false
        }
    }

    export default {
        components: {
            uiSearchBox,
            uiLoadIndicator,
            uiButton,
            uiSelectUser,
            codeConfirmModal
        },

        mixins: [ helpers ],

        props: {
            /**
             * Recebe os métodos do componente TEMPLATE
             * métodos: show, hide e toggle
             */
            methods: {
                type: [Object, Function],
                required: false,
                default() {
                    return {}
                },
            },
            /**
             * Define o modo de visão da tela
             * se for true mostra o input de importar a planilha
             * se for false mostra o formulário de selecionar usuario
             */
            showUpload: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        data() {
            return {
                queueStatusToggle: true,
                layout: {
                    showInputUpload: true,
                    showUploadSuccess: false,
                },
                loader: {
                    fileUpload: false,
                },
                data: [],
                fileEvent: null,
            }
        },

        computed: {
            showUploadComputed() {
                return this.showUpload
            },
            ...mapGetters('lead', {
                leadQueue: 'getQueue',
            }),
        },

        mounted(){
            this.$root.$on('close-sidebar-select-user', () => {
                this.hide()
            })
        },

        beforeDestroy() {
            this.$root.$off('close-sidebar-select-user')
        },

        methods: {
            /**
             * Reseta o layout
             */
            resetLayout() {
                this.layout = { ...defaultLayout() }
            },

            /**
             * Reseta os loadings
             */
            resetLoader() {
                this.loader = { ...defaultLoader() }
            },

            /**
             * Executa o médoto de esconder o sidebar
             * O método vem do template
             */
            hide() {
                if (this.methods && this.methods.hide) {
                    this.methods.hide()
                }
            },

            /**
             * Executa o médoto de esconder o sidebar
             * O método vem do template
             */
            show() {
                if (this.methods && this.methods.show) {
                    this.methods.show()
                }
            },
            /**
             * Pega as colunas da planilha pelo tipo de disponibilidade
             */
            compareColumns() {
                //OBJETO HORIZONTAL COM CAMPOS QUE TEM QUE TER NA PLANILHA
                let leads = []
                leads['A'] = { nameDb:'name', nameColumn:'Nome', required: true }
                leads['B'] = { nameDb:'email', nameColumn:'E-mail' }
                leads['C'] = { nameDb:'phone', nameColumn:'Telefone' }
                leads['D'] = { nameDb:'mobile', nameColumn:'Celular' }
                leads['E'] = { nameDb:'cpf', nameColumn:'CPF' }

                return leads
            },
            openCodeConfirmModal(e) {
                this.fileEvent = e
                this.$root.$emit('modal-msg-open-code-confirm-modal');
            },
            async confirmCodeConfirmModal() {
                this.$root.$emit('modal-msg-close-code-confirm-modal');
                await this.fileUploadHandler(this.fileEvent)
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.value = null
                }
            },
            /**
             * Submita os leads advindos do arquivo importado
             */
            submitLeads(customers) {
                if (!customers.length) {
                    this.$toastr.w('Não foram identificados clientes/leads na planilha')
                    return
                }
                this.$set(this.layout, 'showInputUpload', false)
                this.$set(this.loader, 'fileUpload', true)
                const params = {
                    lead_id: this.leadQueue.id,
                    customers: JSON.stringify(customers)
                }
                lead.create('import', params)
                    .then(response => {
                        this.$toastr.s(response.data.msg)

                        this.$set(this.layout, 'showUploadSuccess', true)
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    })
                    .finally(() => {
                        this.$set(this.loader, 'fileUpload', false)
                        setTimeout(() => {
                            this.$set(this.layout, 'showUploadSuccess', false)
                            this.$set(this.layout, 'showInputUpload', true)
                        }, 200)
                    })
            },
            /**
             * Método estatico para simular o loading do componente Select User
             */
            fileUploadHandler: async function(event) {
                this.$set(this.layout, 'showInputUpload', false)
                this.$set(this.loader, 'fileUpload', true)
                let objectCustomer = []
                try {
                    /** Monta as unidades a partir da planilha */
                    const result = await this.alasql.promise('SELECT * FROM XLS(?,{headers:false})',[event])
                    /** Verifica se existe a coluna 0 na planilha */
                    if (result && result[0]) {
                        let spreadsheetHeader = result[0]

                        /** Verifica se a coluna inserida é Facilita */
                        if (spreadsheetHeader['A'] == 'Facilita' && spreadsheetHeader['D']) {
                            /** Pega o Valor da coluna para validação de formulário */
                            let nameColumnInvalid = null
                            let spreadsheetType = spreadsheetHeader['D']
                            let validFields = result[3]
                            /** Verifica se a planilha é realmente de clientes/leads */
                            if (spreadsheetType != 'CLIENTES') throw new Error(`Essa planilha não é valida!`)

                            /** Valida se os campos obrigatórios estão na planilha */
                            let isValid = true
                            let fieldsRequired = this.compareColumns()

                            /** Valida se as colunas estão corretas */
                            Object.keys(fieldsRequired).forEach(key => {
                                /* Verifica se as colunas da tabela são válidas */
                                if (validFields[key] && validFields[key].replace('*', '') != fieldsRequired[key].nameColumn) {
                                    nameColumnInvalid = nameColumnInvalid
                                        ? nameColumnInvalid + ',' + fieldsRequired[key].nameColumn
                                        : fieldsRequired[key].nameColumn
                                    isValid = false
                                }
                            })

                            /** Se todas as colunas estiveram corretas */
                            if (isValid) {
                                result.forEach((dataCustomer, index) => {
                                    /** Dados das unidades iniciam na coluna 4 */
                                    if (index > 3) {
                                        /** Monta o objeto para a API */
                                        let customer = {}
                                        Object.keys(fieldsRequired).forEach(function (key) {
                                            /** Verifica se o valor é válido */
                                            customer[fieldsRequired[key].nameDb] = dataCustomer[key] || ''
                                        })

                                        /** Verifica se o objeto Unit não está vazio de modo a não criar uma unidade vazia */
                                        if (customer &&
                                            !(Object.keys(customer).length === 0 && customer.constructor === Object) &&
                                            customer.name) {
                                            objectCustomer.push(customer)
                                        }
                                    }
                                })
                                this.$set(this.loader, 'fileUpload', false)
                                this.$set(this.layout, 'showInputUpload', true)
                                this.submitLeads(objectCustomer)

                            } else {
                                throw new Error(`O(s) campo(s) ${nameColumnInvalid} não existe na tabela, essa planilha não é valida`)
                            }

                        } else {
                            throw new Error('Planilha não é do modelo Facilita')
                        }

                    } else {
                        throw new Error('Planilha não é do modelo Facilita')
                    }

                } catch (error) {
                    if (error.message) {
                        this.$toastr.e(error.message)

                    } else {
                        this.$toastr.e(`Tipo de planilha invalida:, ${error}`)
                    }
                    this.$set(this.loader, 'fileUpload', false)
                    this.$set(this.layout, 'showInputUpload', true)
                }
            },
            /**
             * Método estatico para simular o loading do componente Select User
             */
            downloadsPreadsheet() {
                window.open("https://cdn.appfacilita.com/static/planilha-leads/planilha_facilita_leads.xlsx?v=1627687070")
            },
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
